export async function getSiteSettings() {
  const url = `${process.env.REACT_APP_API_URL}/api/globals/site-settings`;
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(
      `Site settings request failed: ${response.status} ${response.statusText}`
    );
  }

  return response.json();
}
